// extracted by mini-css-extract-plugin
module.exports = {"background":"W_dC","values":"W_dD"};